import { Component, Inject, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DepartureCreate, DepartureVM, StationVM, TerminalVM } from '../../../../../models/ArrivalDepartureModel';
import { ArrivalDepartureService } from '../../../../../services/arrivaldeparture.service';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import moment from 'moment';

@Component({
    selector: 'app-departure-new',
    templateUrl: './departure-new.component.html',
    styleUrls: ['./departure-new.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DepartureNewComponent implements OnInit, OnDestroy {
  departureVM: DepartureVM;
  stationsVM: StationVM[] = [];
  terminalsVM: TerminalVM[] = [];
  departureCreate: DepartureCreate;


  @Input() organizationId: string = 'A848CCD3-FD8D-4035-925E-571EBB4E93E8';

  createDepartureForm: UntypedFormGroup;

  isDisabled: boolean = false;
  stationId: string;
  terminalId: string;
  scheduledDeparture: string;
  time: string;
  departureCode: string;

  isLoading: boolean = false;
  activeRequests: number = 0;

  componentDestroyed$: Subject<boolean> = new Subject();

  constructor(
    public snackBar: MatSnackBar,
    public router: Router,
    public arrivalDepartureService: ArrivalDepartureService,
    private fb: UntypedFormBuilder,
  ) {}

  ngOnInit(): void {
    this.initCreateDeparture();
  }

  setLoading(isLoading: boolean){
    this.isLoading = isLoading;
  }

  incrementActiveRequests(){
    this.activeRequests++;
    if(this.activeRequests === 1){
      this.setLoading(true);
    }
  }

  decrementActiveRequests(){
    if(this.activeRequests > 0){
      this.activeRequests--;
    }
    if(this.activeRequests === 0){
      this.setLoading(false);
    }
  }

  initCreateDeparture() {
    this.scheduledDeparture = moment().format();
    this.time = "00:00";
    this.initCreateDepartureForm();
    this.getStations();
    this.terminalsVM = [];
  }

  initCreateDepartureForm() {
    this.createDepartureForm = this.fb.group({
      scheduledDeparture: [this.scheduledDeparture, Validators.required],
      time: [this.time, Validators.required],
      departureCode: [this.departureCode, Validators.required]
    });
  }

  getStations() {
    this.incrementActiveRequests();
    this.terminalsVM = [];
    this.arrivalDepartureService
      .getStations(this.organizationId)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(stationsVM => {
        this.stationsVM = stationsVM;
        this.decrementActiveRequests();
      });
  }

  getTerminals(stationId: string) {
    this.incrementActiveRequests();
    this.arrivalDepartureService
      .getTerminals(stationId)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(terminalsVM => {
        this.terminalsVM = terminalsVM;
        this.decrementActiveRequests();
      });
  }

  stationChange(event) {
    if (event.value !== null) {
      this.stationId = event.value
      this.getTerminals(this.stationId);
    }
  }

  terminalChange(event) {
    if (event.value !== null) {
      this.terminalId = event.value;
    }
  }

  saveDeparture() {
    this.incrementActiveRequests();
    this.departureCreate = this.getSaveData();
    this.arrivalDepartureService
    .createDeparture(this.departureCreate)
    .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(departureVM => {
        this.departureVM = departureVM;
        this.clearForm();
        this.snackBar.open('Avgången är skapad', 'OK', {
          verticalPosition: 'top'
        });
        this.decrementActiveRequests();
      },
      error => {
        this.snackBar.open(`Felkod: ${error.status}`, 'Doh!', {
          verticalPosition: 'top'
        });
        this.decrementActiveRequests();
      });
  }

  getSaveData() : DepartureCreate {

    let departureCreate: DepartureCreate = {
      departureCode: '',
      scheduledDeparture: '',
      stationId: '',
      terminalId: ''
    };

    departureCreate.stationId = this.stationId;
    departureCreate.terminalId = this.terminalId;
    departureCreate.departureCode = this.createDepartureForm.controls['departureCode'].value;
    departureCreate.scheduledDeparture = moment(this.createDepartureForm.controls['scheduledDeparture'].value).format('YYYY-MM-DD') + 'T' + this.createDepartureForm.controls['time'].value;

    return departureCreate;
  }

  clearForm() {
    this.createDepartureForm.reset();
    this.initCreateDeparture();
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
